<template>
  <div>
    <div v-if="hasTabItems" class="booking__route-wrapper">
      <ul class="booking__routes">
        <li class="booking__routes-item">
          <input
            type="radio"
            @change="changeHotelRoute('internal')"
            name="hotelTypes"
            value="internal"
            id="internalHotel"
            class="radio-button"
            v-model="hotelType"
            autocomplete="off"
          />
          <label for="internalHotel"> هتل داخلی </label>
        </li>

        <li class="booking__routes-item">
          <input
            type="radio"
            @change="changeHotelRoute('external')"
            name="hotelTypes"
            value="2"
            id="externalHotel"
            class="radio-button"
            v-model="hotelType"
            autocomplete="off"
          />
          <label for="externalHotel"> هتل خارجی </label>
        </li>
      </ul>
    </div>

    <div class="booking__inner">
      <div class="booking__items" v-if="hotelType === 'internal'">
        <div
          class="booking__item booking__item--departure booking__item--hotel-departure"
        >
          <Destination
            :title="'جستجوی نام شهر'"
            :label="'مقصد'"
            :destination-type="2"
            :header="'انتخاب مقصد'"
            :origin-place="false"
            airport-type="external"
            @fill-next-input="fillNextInput"
            ref="destination"
          />
        </div>

        <div class="booking__item booking__item--date booking__item--two-date">
          <Datepicker
            type="entryDate"
            title="تاریخ رفت"
            @date-changed="dateChanged"
            @fill-next-input="fillNextInput"
            @set-date-diff="setDateDiff"
            @clear-date-diff="clearDateDiff"
            ref="entryDate"
          />

          <Datepicker
            type="exitDate"
            title="تاریخ برگشت"
            :min-date="exitDateMin"
            @fill-next-input="fillNextInput"
            @set-date-diff="setDateDiff"
            ref="exitDate"
          />

          <div class="search-box__night-number" v-if="dateDiff">
            <span>
              {{ dateDiff }}
            </span>
            <span> شب </span>
          </div>
        </div>

        <div class="booking__item booking__item--travellers">
          <Travellers ref="travellers" />
        </div>
      </div>

      <div class="booking__items" v-else-if="hotelType === 'external'">
        <div
          class="booking__item booking__item--departure booking__item--hotel-departure"
        >
          <Destination
            :title="'جستجوی نام شهر'"
            :label="'مقصد'"
            :destination-type="1"
            :header="'انتخاب مقصد'"
            :origin-place="false"
            airport-type="external"
            @fill-next-input="fillNextInput"
            ref="destination"
          />
        </div>

        <div class="booking__item booking__item--date booking__item--two-date">
          <Datepicker
            type="entryDate"
            title="تاریخ رفت"
            @date-changed="dateChanged"
            @fill-next-input="fillNextInput"
            @set-date-diff="setDateDiff"
            @clear-date-diff="clearDateDiff"
            ref="entryDate"
          />

          <Datepicker
            type="exitDate"
            title="تاریخ برگشت"
            :min-date="exitDateMin"
            @fill-next-input="fillNextInput"
            @set-date-diff="setDateDiff"
            ref="exitDate"
          />

          <div class="search-box__night-number" v-if="dateDiff">
            <span>
              {{ dateDiff }}
            </span>
            <span> شب </span>
          </div>
        </div>

        <div class="booking__item booking__item--travellers">
          <Travellers ref="travellers" />
        </div>
      </div>
      <button
        @click="searchHotel"
        class="booking__search btn btn--primary btn--xl"
        title="جستجو"
      >
        جستجو
        <i class="icon-arrow-left" />
      </button>
    </div>
  </div>
</template>
<script>
import moment from "moment-jalaali";

import Departure from "./Departure.vue";
import Destination from "./Destination.vue";
import Datepicker from "./Datepicker.vue";
import Travellers from "./Travellers.vue";
import { showAlert } from "../../../../Helpers/tools";

export default {
  name: "HotelItems",
  props: {
    hotelType: {
      type: String,
      default: "",
    },
    hasTabItems: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Departure,
    Destination,
    Datepicker,
    Travellers,
  },

  data() {
    return {
      baseUrl: "/fa/hotel/",

      exitDateMin: moment(Date().now).format("jYYYY/jMM/jDD"),

      duration: "",

      dateDiff: null,
    };
  },
  methods: {
    changeHotelRoute(type) {
      this.hotelType = type;
    },

    searchHotel() {
      let destination = this.$refs.destination;

      let entryDate = this.$refs.entryDate.date;

      let exitDate = this.$refs.exitDate.date;

      let travellers = this.$refs.travellers;

      let adultsString = "";
      let childString = "";
      let childAgeString = "";
      let roomsCount = 1;
      let sort = "";
      let filter = "";

      travellers.rooms.forEach((room) => {
        adultsString += `&a=${room.adults}`;

        childString += `&c=${room.childs.length}`;

        if (room.childs.length) {
          room.childs.forEach((child) => {
            childAgeString += `&g=${Number(child)}`;
          });
        }
      });
      roomsCount = travellers.roomsCount;

      if (window.hotelDataModel && window.hotelDataModel.sort) {
        sort = `&sort=${window.hotelDataModel.sort}`;
      }

      if (
        window.hotelDataModel &&
        window.hotelDataModel.filter !== null &&
        Object.keys(window.hotelDataModel.filter).length
      ) {
        for (let i in window.hotelDataModel.filter) {
          filter = `&${i}=${window.hotelDataModel.filter[i]}`;
        }
      }

      let url = this.baseUrl;

      let valid = this.checkValidation();

      if (!valid) {
        return;
      }

      if (destination.hotel.locationType === 1) {
        url += `${destination.hotel.countrySlug}/${destination.hotel.citySlug}`;
      } else if (destination.hotel.locationType === 2) {
        url += `${destination.hotel.countrySlug}/${destination.hotel.citySlug}/${destination.hotel.slug}`;
      }
      url += `/?i=${entryDate}&o=${exitDate}&r=${roomsCount}&d=${destination.hotel.id}&lt=${destination.hotel.locationType}&dt=${destination.hotel.destinationType}${adultsString}${childString}${childAgeString}${sort}${filter}`;
      window.location.assign(url);
    },

    calcDiffDate() {
      var startDate = this.$refs.entryDate.date;
      var endDate = this.$refs.exitDate.date;
      const date1 = new Date(startDate);
      const date2 = new Date(endDate);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      this.duration = diffDays;
    },

    checkValidation() {
      let valid = true;

      let destination = this.$refs.destination;

      let entryDate = this.$refs.entryDate.date;

      let exitDate = this.$refs.exitDate.date;

      if (!destination.selectedHotel) {
        showAlert([
          {
            type: 8,
            message: "مقصد را انتخاب کنید",
          },
        ]);

        valid = false;
      }

      if (this.destinationType === 1) {
        if (!nationality.nationalityCode) {
          showAlert([
            {
              type: 8,
              message: "ملیت خود را انتخاب کنید",
            },
          ]);

          valid = false;
        }
      }

      if (!entryDate) {
        showAlert([
          {
            type: 8,
            message: "تاریخ ورود را انتخاب کنید",
          },
        ]);

        valid = false;
      }

      if (!exitDate) {
        showAlert([
          {
            type: 8,
            message: "تاریخ خروج را انختاب کنید",
          },
        ]);

        valid = false;
      }

      let dateDifference = moment(exitDate, "YYYY/M/D").diff(
        moment(entryDate, "YYYY/M/D"),
        "days"
      );

      if (dateDifference > 20) {
        showAlert([
          {
            type: 8,
            message: "بازه تاریخ ورود و خروج نباید بیشتر از 20 روز باشد",
          },
        ]);

        valid = false;
      }

      return valid;
    },
    fillNextInput() {
      let timeOut;
      if (this.$refs.entryDate.date !== "" && this.$refs.exitDate.date !== "") {
        this.calcDiffDate();
      }

      if (this.hotelType !== 3) {
        let departureDate = this.$refs.entryDate;
        let returnDate = this.$refs.exitDate;

        if (!departureDate.date) {
          timeOut = setTimeout(() => {
            departureDate.$refs.datepicker.showPicker();
            clearTimeout(timeOut);
          }, 50);

          return;
        }

        if (!returnDate.date) {
          timeOut = setTimeout(() => {
            returnDate.$refs.datepicker.showPicker();
            clearTimeout(timeOut);
          }, 50);

          return;
        }
      }
    },

    // get date from entryDate and set to exitDate min
    dateChanged(event) {
      this.exitDateMin = moment(event).format("jYYYY/jMM/jDD");
      this.$refs.exitDate.reset();
    },

    setDateDiff() {
      let startDate = moment(this.$refs.entryDate.date);
      let endDate = moment(this.$refs.exitDate.date);

      this.dateDiff = moment.duration(endDate.diff(startDate)).asDays();
    },

    clearDateDiff() {
      this.dateDiff = null;
    },
  },

  mounted() {
    window.destinationInput = this.$refs.destination;
    window.searchBoxEntryDate = this.$refs.entryDate;
  },
};
</script>
